import { memo, useCallback, useRef } from "react";
import SelectInputUI from "components/Form/UI/Select/SelectInputUI";
import useQueryParam from "hooks/useQueryParam";

const Dropdown = (props) => {
  const {
    keyName = "status",
    defaultValue = "",
    extraParams = {},
    id = "",
    ...rest
  } = props;
  const selectRef = useRef(null);
  const [value, setValue] = useQueryParam(keyName, defaultValue);

  const onChange = useCallback(
    (event) => {
      setValue({
        [keyName]: event.target.value,
        search: null,
        page: 1,
        ...extraParams,
      });
    },
    [setValue,keyName, extraParams],
  );

  return (
    <SelectInputUI
      {...rest}
      ref={selectRef}
      id={id || keyName}
      onChange={onChange}
      value={value}
      sx={{
        width: 148,
        "& .MuiOutlinedInput-root": {
          height: 40,
        },
      }}
    />
  );
};

export default memo(Dropdown);
